import {
    Box,
    css,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { staticFileLocation } from '@server/constants';
import { bold, semibold } from '@styles/fontWeights';
import { useLogout } from '@features/applications/hooks/useLogout';
import { LoadingButton } from '@mui/lab';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

type DisabledCompanyModalProps = {
    isCompanyDisabledModal: boolean;
    handleClose: () => void;
};

const DisabledCompanyModal: FC<DisabledCompanyModalProps> = ({
    isCompanyDisabledModal,
    handleClose,
}) => {
    const [isLoading, setLoading] = useState<Boolean>(false);

    const handleLogout = async (event: { preventDefault: () => void }) => {
        event.preventDefault();
        await useLogout({ setLoading });
    };
    return (
        <Dialog
            open={isCompanyDisabledModal}
            maxWidth="xs"
            fullWidth
            disableEnforceFocus
            sx={{ background: 'transparent' }}
        >
            <DialogTitle >
                <Box display="flex" justifyContent="center" alignItems="center">
                    <img
                        src={`${staticFileLocation}img/logos/TwoColorLogo.png`}
                        alt="Logo"
                        css={css`
                        max-height: 60px;
                        display: block;
                        `}
                    />
                </Box>
            </DialogTitle>
            <DialogContent>
                <Stack sx={{ px: { sm: 4, md: 5 } }} alignItems='center' pb={4} spacing={2}>
                    <Typography fontWeight={bold} variant="h3" >
                        Uh Oh!
                    </Typography>
                    <Typography fontWeight={semibold} textAlign='center' variant="h4" >
                        Looks like your account has been Deactivated.
                    </Typography>
                </Stack>
                <Stack mb={3}>
                    <LoadingButton
                        loading={Boolean(isLoading)}
                        disabled={Boolean(isLoading)}
                        variant="contained"
                        color="error"
                        startIcon={<LogoutOutlinedIcon />}
                        onClick={(e) => handleLogout(e)}
                    >
                        Logout
                    </LoadingButton>
                </Stack>
            </DialogContent>
        </Dialog >
    );
};

export default DisabledCompanyModal;
